// extracted by mini-css-extract-plugin
export default {"main":"slideway_main__LEoL0"};